import * as utils from '../../../shared';
export function shortCountries(fullName: string): string {
  return utils.shortCountries(fullName);
} 